// extracted by mini-css-extract-plugin
module.exports = {"root":"CVs_root__1fZpV","actions":"CVs_actions__3lfLG","visuallyHidden":"CVs_visuallyHidden__3m6fh"};